import React, { ForwardRefRenderFunction } from "react";
import FeedbackType from "../../FeedbackType";
import colors from "../../style/colors";

type Pixel = number;

export type RawUnderlineProps = {
  height: Pixel;
  width: Pixel;
  left: Pixel;
  top: Pixel;
  type: FeedbackType;
  isHighlighted: boolean;
  gated: boolean;
};

const RawUnderline: ForwardRefRenderFunction<
  HTMLDivElement,
  RawUnderlineProps
> = (
  { height, width, left, top, type, isHighlighted, gated }: RawUnderlineProps,
  ref: React.Ref<HTMLDivElement>
) => {
  let bgColor = colors.actionable[type].background;
  if (gated) {
    bgColor = "bg-gating-gray";
  }
  return (
    <div
      ref={ref}
      style={{ width, height, left, top }}
      className="Underline absolute pointer-events-none"
    >
      {/* Highlight */}
      <div
        className={`w-full h-full ${
          isHighlighted ? bgColor : ""
        } transition-colors ease-in-out opacity-20 pointer-events-none duration-100`}
      />
      {/* Underline */}
      <div
        style={{ width, height: "3px" }}
        className={`bottom-0 absolute ${bgColor} pointer-events-none transition-colors ease-in-out duration-100 rounded-full`}
      />
      <div className="pointer-events-auto" />
    </div>
  );
};

RawUnderline.displayName = "RawUnderline";

export default React.forwardRef(RawUnderline);
